import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import CustomButton from 'components/CustomButton';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    padding: theme.spacing(4),
  },
  comingSoon: {
    textAlign: 'center',
    padding: theme.spacing(8),
    backgroundColor: theme.palette.neutral['clr-50'],
    borderRadius: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
}));

const CreatePersonalizedChallenge = memo(({ handleBack }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <CustomButton onClick={handleBack} variant="outlined">
          ← Back
        </CustomButton>
        <Typography variant="h3-semiBold" color="neutral.clr-900">
          Personalized Case Studies
        </Typography>
      </Box>

      <Box className={classes.comingSoon}>
        <Typography variant="h4-semiBold" color="neutral.clr-900" mb={2}>
          Personalized Case Studies Coming Soon
        </Typography>
        <Typography variant="body01-regular" color="neutral.clr-600">
          Create custom case studies tailored to your specific industry and role preferences.
        </Typography>
      </Box>
    </Box>
  );
});

export default CreatePersonalizedChallenge;
